export default {
  navHome: "Startseite",
  navProducts: "Produkte",
  navCases: "Anwendungsbeispiele",
  navAbout: "Über uns",
  deliverTo: "Lieferung nach:",
  langCurrencyLabel: "Deutsch",
  localeLangTitle: "Sprache einstellen",
  localeLangDesc:
    "Wählen Sie Ihre bevorzugte Sprache. Sie können diese Einstellung jederzeit aktualisieren.",
  language: "Sprache",
  save: "Speichern",
  coreProducts: "Kreative Umsetzung in der realen Welt.",
  coreProductsDesc:
    "Von der Idee zum Geschäft �?YONGYUAN bietet UV-Drucker, Kristalletiketten-Drucker, Hochgeschwindigkeits-Zylinderdrucker, DTF- und DTG-Drucker und verwandelt Kreativität in Produkte, Marken und Chancen.",
  scenariosTitle: "Für jedes Szenario die passende Lösung",
  scenariosDesc:
    "Ob Markenaufbau, Nebengeschäft oder kreative Leidenschaft �?YONGYUAN bietet eine Lösung, die auf Ihre Bedürfnisse zugeschnitten ist.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Hochwertige Individualisierung, Kleinserien-Prototypen und Markenaufbau",
  scenarioRetail: "Marken-Einzelhandel",
  scenarioRetailDesc:
    "Längere Verweildauer und höhere Umsätze im Geschäft",
  scenarioMarket: "Marktstand",
  scenarioMarketDesc:
    "Vor-Ort-Anpassung, Verkauf fertiger Produkte und Zusatzeinkommen",
  scenarioEnterprise: "Unternehmensanpassung",
  scenarioEnterpriseDesc:
    "Serienanpassung, Markenartikel und Business-Geschenke",
  scenarioEcommerce: "Livestream-Verkauf",
  scenarioEcommerceDesc:
    "Bestseller-Prototypen, flexible Lieferung und schnelle Markteinführung",
  scenarioStore: "Online-Shop",
  scenarioStoreDesc:
    "Shop-Individualisierung, Bestseller-Merchandise und differenziertes Geschäft",
  scenarioFactory: "Fabrikproduktion",
  scenarioFactoryDesc:
    "Serienfertigung, stabile Ausgabe und Kosteneffizienz",
  scenarioAdvertising: "Werbemittelproduktion",
  scenarioAdvertisingDesc:
    "Beschilderung, Display-Materialien und Event-Materialien",
  industries: "Branchenanwendungen",
  industriesDesc:
    "Digitale Tintenstrahldrucklösungen für Farbdruck in verschiedenen Branchen.",
  applicationsTitle:
    "Vielfältige Material- und Farbanwendungen für Alltag und Gewerbe.",
  applicationsDesc:
    "YONGYUAN UV-Druckgeräte sind für eine breite Palette von Materialien und Prozessszenarien konzipiert und ermöglichen sowohl personalisierte Anpassung als auch Großserienproduktion.",
  casesHeroDesc:
    "Über 1200 Branchenanwendungen und Zehntausende druckbare Materialien — digitale Drucklösungen für unterschiedliche Geschäftsmodelle.",
  casesBreadcrumbHome: "Startseite",
  casesBreadcrumbCenter: "Anwendungsbeispiele",
  casesEmpty: "Noch keine Anwendungsbeispiele in dieser Kategorie.",
  customerStoriesTitle: "Weltweit von Kunden vertraut",
  customerStoriesSubtitle:
    "Echte Installationen, echte Kunden, echte Druckbetriebe in 172 Ländern.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Ausgelieferte Drucker",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Bediente Länder",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Jahre Erfahrung",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Technischer Support",
  customerStoriesPlaceholder: "Kundenfoto hinzufügen",
  customerStoriesPhotoAlt: "YONGYUAN-Kunde mit Drucker",
  servicePartnerTitle:
    "Lernen Sie das YONGYUAN Service-Team kennen �?Ihr kreativer Partner",
  servicePartnerDesc:
    "Ein globales Servicenetzwerk und professionelles Support-System für Ihre Geräteleistung und Ihr Geschäftswachstum.",
  serviceSupportTitle: "Standard-Support",
  serviceSupportDesc:
    "Installationsanleitung, Grundausbildung und tägliche Nutzungsunterstützung für zuverlässigen Betrieb.",
  servicePresaleTitle: "Vorverkaufs-Demo & Beratung",
  servicePresaleDesc:
    "Lösungsdemonstrationen und Modellempfehlungen für Ihre Anwendungsszenarien und Kapazitätsanforderungen.",
  serviceLifetimeTitle: "Lebenslanger technischer Support",
  serviceLifetimeDesc:
    "Fortlaufende technische Reaktion und Prozessunterstützung für Ihre langfristige Geschäftsentwicklung.",
  serviceCareTitle: "Upgrade auf YONGYUAN Care",
  serviceCareDamageTitle: "Schutz bei Unfallschäden",
  serviceCareDamageDesc:
    "Ein umfassenderer Schutzplan zur Reduzierung von Verlusten durch unerwartete Vorfälle.",
  serviceCareExchangeTitle: "Schneller Umtausch-Service",
  serviceCareExchangeDesc:
    "Prioritäre schnelle Umtauschregelungen unter berechtigten Bedingungen zur Beschleunigung der Kapitalrückgewinnung.",
  viewProduct: "Produkte ansehen",
  learnMore: "Mehr erfahren",
  catUv: "UV-Flachbett-Drucker",
  catCylinder: "Zylinderdrucker",
  catCrystal: "Kristalletiketten-Drucker",
  catDtf: "DTF-Drucker",
  catDtg: "DTG-Drucker",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefon: 17748697567 Manager Tang",
  email: "E-Mail: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Alle Rechte vorbehalten",
  productsHeroTitle: "Produkte",
  productsHeroDesc:
    "Vollständiges Sortiment an UV-Flachbett-, Zylinder-, Kristalletiketten-, DTF- und DTG-Geräten für unterschiedliche Kapazitäts- und Anwendungsanforderungen.",
  productsBreadcrumbHome: "Startseite",
  productsBreadcrumbCenter: "Produkte",
  productsEmpty: "Produkte in dieser Kategorie folgen in Kürze.",
  productsQuoteTitle: "Lösung & Angebot anfordern",
  productsQuoteDesc:
    "Teilen Sie uns Ihre Anwendungsszenarien und Kapazitätsanforderungen mit �?wir empfehlen die passende Gerätelösung.",
  productsContact: "Kontakt",
  aboutHeroTitle: "Über Yongyuan",
  aboutHeroDesc:
    "23 Jahre Fokus auf Forschung, Entwicklung und Produktion von UV-Druckgeräten",
  productA23Subtitle: "Desktop 6-Farben intelligenter UV-Drucker",
  productA23Feature1: "A4 Druckformat",
  productA23Feature2: "Intelligentes Tintenversorgungssystem",
  productA23Feature3: "Infrarot-Automatische Höhenmessung",
  productA35Subtitle: "Desktop 6-Farben intelligenter UV-Drucker",
  productA35Feature1: "A3+ Druckformat",
  productA35Feature2: "Intelligentes Tintenversorgungssystem",
  productA35Feature3: "Infrarot-Automatische Höhenmessung",
  productA43Subtitle: "Flaggschiff 8-Farben intelligenter UV-Drucker",
  productA43Feature1: "A3 Druckformat",
  productA43Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA43Feature3: "Intelligentes Tintenversorgungssystem",
  productA46Subtitle: "Flaggschiff 8-Farben intelligenter UV-Drucker",
  productA46Feature1: "A2 Druckformat",
  productA46Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA46Feature3: "Intelligentes Tintenversorgungssystem",
  productA57Subtitle: "Flaggschiff 8-Farben intelligenter UV-Drucker",
  productA57Feature1: "A2+ Druckformat",
  productA57Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA57Feature3: "Intelligentes Tintenversorgungssystem",
  productA69Subtitle: "Flaggschiff 8-Farben intelligenter UV-Drucker",
  productA69Feature1: "A1 Druckformat",
  productA69Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA69Feature3: "Intelligentes Tintenversorgungssystem",
  productA1216Subtitle: "Flaggschiff Großformat-UV-Flachbett-Drucker",
  productA1216Feature1: "1200×1600cm Druckformat",
  productA1216Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA1216Feature3: "Visuelles Positionierungssystem",
  productA2513Subtitle: "Flaggschiff Großformat-UV-Flachbett-Drucker",
  productA2513Feature1: "2500×1300cm Druckformat",
  productA2513Feature2: "Mehrere Druckkopf-Konfigurationen",
  productA2513Feature3: "Visuelles Positionierungssystem",
  productCylinderElfSubtitle: "360° Hochgeschwindigkeits-Zylinderdrucker",
  productCylinderElfFeature1: "360° Rundumdruck",
  productCylinderElfFeature2: "Becher- & Flaschenanpassung",
  productCylinderElfFeature3: "Schneller Vorrichtungswechsel",
  productCupPlusSubtitle: "Mehrgrößen-Becher- und Flaschendrucklösung",
  productCupPlusFeature1: "Mehrgrößen-Vorrichtungen",
  productCupPlusFeature2: "Hohe Produktionseffizienz",
  productCupPlusFeature3: "Stabile Ausgabe",
  productCrystal60Subtitle: "Kristalletikett-Druck- & Folien-All-in-One-System",
  productCrystal60Feature1: "60cm Breite",
  productCrystal60Feature2: "Druck- & Folienintegration",
  productCrystal60Feature3: "Effizientes Aufnahmesystem",
  productCrystalC60UltraFeature1: "60 cm Breite",
  productCrystalC60UltraFeature2: "Gold-/Silber-/3D-Silikonlabel-Optionen",
  productCrystalC60UltraFeature3: "Massenproduktion",
  productCrystal30Subtitle: "Kompakter hochpräziser Kristalletiketten-Drucker",
  productCrystal30Feature1: "Kompakter Präzisionsdruck",
  productCrystal30Feature2: "Einfache Bedienung",
  productCrystal30Feature3: "Personalisierte Anpassung",
  productDtf60Subtitle: "Weißtinte-DTF-Transferdrucker",
  productDtf60Feature1: "Weißtinte-DTF-Transfer",
  productDtf60Feature2: "Reiche Farbschichten",
  productDtf60Feature3: "Bekleidungszubehör",
  productDtfF20Subtitle: "Branchenkleinster Desktop-Weißtinte-DTF-Drucker",
  productDtfF20Feature1: "A4-Format",
  productDtfF20Feature2: "Kleinserien-Anpassung",
  productDtfF20Feature3: "Intelligentes Farbsystem",
  productDtfF30Subtitle: "Desktop-Weißtinte-DTF-Drucker",
  productDtfF30Feature1: "A3-Format",
  productDtfF30Feature2: "Einzelkopf manuell/automatisch wählbar",
  productDtfF30Feature3: "Intelligentes Farbsystem",
  productDtfF30ProSubtitle: "Weißtinte-DTF-Drucker",
  productDtfF30ProFeature1: "A3-Format",
  productDtfF30ProFeature2: "Doppelkopf mit automatischer Folienaufnahme",
  productDtfF30ProFeature3: "Intelligentes Farbsystem",
  productDtfF33Subtitle: "Weißtinte-DTF-Drucker",
  productDtfF33Feature1: "A3-Format",
  productDtfF33Feature2: "Einzelkopf manuell/automatisch wählbar",
  productDtfF33Feature3: "Intelligentes Farbsystem",
  productDtfF70ProSubtitle: "70 cm Breitformat-Weißtinte-DTF-Drucker",
  productDtfF70ProFeature1: "A2-Format",
  productDtfF70ProFeature2: "2�? Druckkopf-Optionen",
  productDtfF70ProFeature3: "Automatisches Ein- und Auszugssystem",
  productDtfF70ProFeature4: "Intelligenter Druckwiederaufnahme-Modus",
  productDtf30Subtitle: "Kompakter Weißtinte-DTF-Drucker",
  productDtf30Feature1: "Kleinserien-Anpassung",
  productDtf30Feature2: "Genaue Farbwiedergabe",
  productDtf30Feature3: "Einfach zu bedienen",
  productDtgPrintSubtitle: "Digitaler Direkt-zu-Textil-Drucker",
  productDtgPrintFeature1: "Mehrmaterial-Direktdruck",
  productDtgPrintFeature2: "Hoher Durchsatz",
  productDtgPrintFeature3: "Stabil & langlebig",
  productDtg3250DSubtitle: "Branchenweit einziges DTF- & DTG-2-in-1-Modell",
  productDtg3250DFeature1: "A3+ Format",
  productDtg3250DFeature2: "DTF- & DTG-Doppelprozess-Druck",
  productDtg3250DFeature3: "Intelligentes Farbsystem",
  productDtg3646TSubtitle: "DTG-Drucker mit Doppelstation",
  productDtg3646TFeature1: "Kontinuierlicher Produktionsmodus",
  productDtg3646TFeature2: "100 % Produktivitätssteigerung",
  productDtg3646TFeature3: "Intelligentes Farbsystem",
  productDtgMaxSubtitle: "Industrieller digitaler DTG-Drucker",
  productDtgMaxFeature1: "Industrielle Kapazität",
  productDtgMaxFeature2: "Stabil & langlebig",
  productDtgMaxFeature3: "Dauerbetrieb",
  app01Title: "Handyhüllen",
  app02Title: "Golfbälle",
  app03Title: "Steintafeln",
  app04Title: "Kugelschreiber",
  app05Title: "Brillenetuis",
  app06Title: "Holzschnitt-Drucke",
  app07Title: "Getränkedosen",
  app08Title: "Tastaturen",
  app09Title: "Thermosbecher",
  app10Title: "Gepäck",
  app11Title: "Acrylprodukte",
  app12Title: "Notizbücher",
  app13Title: "Abzeichen",
  app14Title: "Leder-Kartenetuis",
  app15Title: "Erkennungsmarken",
  app16Title: "Glaskunst",
  appDtgCase01: "T-Shirts",
  appDtgCase02: "Hoodies",
  regionCn: "China",
  regionUs: "Vereinigte Staaten",
  regionGb: "Vereinigtes Königreich",
  regionDe: "Deutschland",
  regionAe: "VAE",
  regionIn: "Indien",
  regionJp: "Japan",
  regionVn: "Vietnam",
  regionBr: "Brasilien",
  regionAu: "Australien",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
